import React, { useState } from "react";
import { useGetUserScoreQuery } from "../store/caseSimulation/CaseStudyApiSlice";
import { getAchievementSrc, GetBadgeName } from "./helpers";
import { useGetProfileQuery } from "../store/profile/UserApiSlice";
import { useNavigate } from "react-router-dom";
import ScoreBoardBanner from "./scoreboardbanner";
import config from "../config/APIEndpoints";
const headerbadge =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/headerbadge.svg";
const fireicon =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/fire.svg";
const reloadicon =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/reload.svg";
const OpenIcon =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/sidebar/open.svg";
const CloseIcon =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/sidebar/close.svg";
const GripLine =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/sidebar/griplinessidebar.svg";
const ProfileIcon =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/profile.svg";

const UserIcon =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/profilevectro.svg";

export default function HomemainHeader({ header, onToggle }) {
  const { data, isLoading } = useGetUserScoreQuery();

  const navigate = useNavigate();
  const { data: profileData } = useGetProfileQuery();
  const [isScoreboardVisible, setIsScoreboardVisible] = useState(false);
  const toggleScoreboard = () => {
    setIsScoreboardVisible(!isScoreboardVisible);
  };
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const toggleSidebar = () => {
    setIsSidebarCollapsed((prevState) => !prevState);
  };
  const handleNavigation = (path) => {
    navigate(path);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  return (
    <>
      <div className="homemainheader mobilevisibleonly dashboardheadermobile">
        <div className="homemainleft">
          <div className="homemainleftinner">
            <div className="closesidebarbutton" onClick={toggleSidebar}>
              <img
                src={isSidebarCollapsed ? OpenIcon : CloseIcon}
                alt="Arrow"
              />
            </div>
            <div className="closesidebarbuttonmobileheader" onClick={onToggle}>
              <img src={GripLine} alt="Arrow" />
            </div>
          </div>

          {header ? (
            <div className="homemainleftouter">
              <h3>{header}</h3>
            </div>
          ) : (
            <div className="homemainleftouter">
              <h3>Hello Dr. {profileData?.profile?.first_name}</h3>
              <p>Ready to Elevate your Medical Journey?</p>
            </div>
          )}
        </div>
        <div
          className="homemainright"

          // onMouseEnter={toggleScoreboard}
          // onMouseLeave={toggleScoreboard}
        >
          {data?.score > 50 ? (
            <button
              onClick={() => {
                navigate("/leaderboard");
              }}
            >
              <div className="homemainrightbuttoncontent">
                <img
                  src={getAchievementSrc(data?.score || 0)}
                  alt="Header Badge"
                />
                <span>
                  <b>{GetBadgeName(data?.score)}</b> Badge
                </span>
              </div>
              <div className="headerstreaks">
                <img src={fireicon} alt="Fire" />
                <p>{data?.score || 0}</p>
              </div>
            </button>
          ) : (
            <button
              onClick={() => {
                navigate("/leaderboard");
              }}
            >
              <h6>Let’s get started and earn badges</h6>
            </button>
          )}
          <button
            onClick={() => {
              navigate("/profile?page=history");
            }}
          >
            <img src={reloadicon} alt="Reload" />
          </button>
          <div className="usericonscore">
            <img
              src={
                profileData?.profile?.profile_pic
                  ? `${config.getEndpoint()}${
                      profileData?.profile?.profile_pic
                    }`
                  : UserIcon
              }
              style={{
                width: "40px",
                height: "40px",
                borderRadius: "50%",
                objectFit: "cover",
                border: "1px solid #ccc",
              }}
              alt="User"
              className="dashboardheadericon"
              onClick={() => handleNavigation("/profile")}
            />
            <div className="userscoremobile">
              <p>{data?.score || 0}</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
